// Sizes used to generate resized and optimized versions of an image.
// Generated in `srcset`, and informed by `sizes`.
export const Screens = {
  xs: 160,
  sm: 338,
  md: 676,
  lg: 1352,
  xl: 2704,
} as const;

export interface ImageSizeCondition {
  mediaQuery: string;
  screenMinWidth: number;
  size: string;
}

export enum ImageRadius {
  None = 'none',
  Rounded = 'rounded',
  Circle = 'circle',
}

export type ImageRadii = `${ImageRadius}`;

export enum ImageProviders {
  Cloudinary = 'cloudinary',
  Static = 'static',
}
